import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Button, Table, Badge, Tag } from 'antd';
import ReactJson from 'react-json-view';

class JobPickerTable extends Component {
    timeConversion = (millisec) => {
        var seconds = (millisec / 1000).toFixed(1);

        var minutes = (millisec / (1000 * 60)).toFixed(1);

        var hours = (millisec / (1000 * 60 * 60)).toFixed(1);

        var days = (millisec / (1000 * 60 * 60 * 24)).toFixed(1);

        if (seconds < 60) {
            return seconds + " sec";
        } else if (minutes < 60) {
            return minutes + " min";
        } else if (hours < 24) {
            return hours + " hrs";
        } else {
            return days + " days"
        }
    }

    getColumns = () => {
        return [
            {
                title: 'Date',
                dataIndex: 'dateScheduled',
                key: 'dateScheduled',
                render: (one, two) => moment(two.dateScheduled).format('DD MMM, h:mm:ss'),
                sorter: (a, b) => {
                    if (a.dateScheduled < b.dateScheduled) { return -1; }
                    if (a.dateScheduled > b.dateScheduled) { return 1; }
                    return 0;
                },
            },
            {
                title: 'Status',
                key: 'status',
                filters: [{ text: 'Working/Done', value: 'valid' }, { text: 'Cancelled', value: 'invalid' }],
                defaultFilteredValue: ['valid'],
                onFilter: (value, item) => {
                    const invalidStatus = ['cancelled'];
                    if (value === 'valid') {
                        return !invalidStatus.includes(item.jobStatus);
                    } else {
                        return invalidStatus.includes(item.jobStatus);
                    }
                },
                render: item => {
                    const { jobStatus } = item;
                    switch (jobStatus) {
                        case 'cancelled': {
                            return (
                                <span>
                                    <Badge status="error" style={{ color: '#ee9900' }} />
                                    Cancelled
                                </span>
                            );
                        }
                        case 'finished': {
                            return (
                                <span>
                                    <Badge status="success" style={{ color: '#ee9900' }} />
                                    Done
                                </span>
                            );
                        }
                        case 'screenshot':
                        case 'scheduled':
                        case 'crawl_working':
                        case 'crawl_done':
                        case 'scrape_queued':
                        case 'scrape_working':
                        case 'working':
                        case 'running':
                        default: {
                            // add qestion sign and explainer that you will receive an email notifictaion
                            return (
                                <span>
                                    <Badge status="processing" style={{ color: '#ee9900' }} />
                                    In Progress...
                                </span>
                            );
                        }
                    }
                },
            },
            {
                title: 'Pages Discovered',
                dataIndex: 'crawlPageCount',
                key: 'crawlPageCount',
                render: (v, r) => r.analytics ? r.analytics.crawlPageCount : <Tag>N/A</Tag>, 
            },
            {
                title: 'Broken Links',
                dataIndex: 'brokenLinks',
                key: 'brokenLinks',
                render: (v, r) => r.analytics ? r.analytics.links.totalUnealthyLinksCount : <Tag>N/A</Tag>, 
            },
            {
                title: 'Healthy Links',
                dataIndex: 'healthyLinks',
                key: 'healthyLinks',
                render: (v, r) => r.analytics ? r.analytics.links.totalHealthyLinksCount : <Tag>N/A</Tag>, 
            },
            {
                title: 'Health Score',
                dataIndex: 'healthScore',
                key: 'healthScore',
                render: (v, r) => r.analytics ? r.analytics.healthScore : <Tag>N/A</Tag>, 
            },
            {
                title: 'Actions',
                dataIndex: 'actions',
                key: 'details',
                render: (v, r) => <div>
                    {/* <Button onClick={() => this.props.onOpenReport(r.jobId)} disabled={!r.analytics} type="primary">Open Report</Button> */}
                    <Button onClick={() => this.props.onOpenReport(r.jobId)} disabled={!r.analytics}>Quick View</Button>
                </div>
            },
        ];
    }

    expandedRowRender = record => {
        return (
            <div>
                <ReactJson src={record} />
            </div>
        )
    }

    render() {
        const { data, loading } = this.props;
        console.log('about to render table with data', data);
        return (
            <Table
                dataSource={_.sortBy(data, 'created').reverse()}
                columns={this.getColumns()}
                pagination={{
                    pageSize: 10,
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                }}
                // expandedRowRender={this.expandedRowRender}
                loading={loading}
                rowKey='jobId'
                size="small"
                bordered={false}
            />
        )
    }
}

export default JobPickerTable;
